import { journeyAction, } from './base';

import { JourneyActionStartChat as JourneyActionStartChatBase, } from 'atlas-shared';

export const JourneyActionStartChat = journeyAction({
  ...JourneyActionStartChatBase,
  icon: 'Chat',
});
